<nav class="navbar navbar-expand navbar-light bg-white topbar static-top shadow main-header">
    <a (click)='removeBack()' [routerLink]="['/dashboard']"><img [src]="logo"></a>
    <!-- Sidebar Toggle (Topbar) -->
    <button id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3">
      <i class="fa fa-bars">A</i>
    </button>
    <!--
    <div class="text-center d-none d-md-inline visible-md close-sidebar-btn">
      <button class="rounded-circle border-0" id="sidebarToggle"></button>
    </div>-->
    <!-- Topbar Search -->
    <!-- Topbar Navbar -->
    <ul class="navbar-nav ml-auto">
      <!-- Nav Item - Search Dropdown (Visible Only XS) -->
      <li class="nav-item dropdown no-arrow d-sm-none">
        <a class="nav-link dropdown-toggle" href="javascript:;" id="searchDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fa fa-search fa-fw"></i>
        </a>
        <!-- Dropdown - Messages -->
        <div class="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in" aria-labelledby="searchDropdown">
          <form class="form-inline mr-auto w-100 navbar-search">
            <div class="input-group">
              <input type="text" class="form-control bg-light border-0 small" placeholder="Search for..." aria-label="Search" aria-describedby="basic-addon2">
              <div class="input-group-append">
                <button class="btn btn-primary" type="button">
                  <i class="fa fa-search fa-sm"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </li>
      <!--<div class="topbar-divider d-none d-sm-block"></div>-->
      <!-- Nav Item - User Information -->
      <li class="nav-item dropdown no-arrow">
        <a class="nav-link dropdown-toggle" href="javascript:;" (click)="openDropdown()">
          <span class="mr-2 d-none d-lg-inline small">Welcome, {{authService.userEmail}}</span>
          <i class="fa fa-user-circle fa-lg"></i>
        </a>
        <!-- Dropdown - User Information -->
        <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in {{ isOpen ? 'show' : '' }}" aria-labelledby="userDropdown">
          <!--<a class="dropdown-item" href="javascript:alert('This functionality will be covered in phase II.');">
            <i class="fa fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
            Profile
          </a>
          <a class="dropdown-item" href="javascript:alert('This functionality will be covered in phase II.');">
            <i class="fa fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
            Settings
          </a>
          <div class="dropdown-divider"></div>-->
          <a class="dropdown-item" href="javascript:;" (click)="logout()">
            <i class="fa fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
            Logout
          </a>
        </div>
      </li>

    </ul>

  </nav>

@if (warningText) {
  <div class="session-warning-toast">
    <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
    <!-- read out once; the countdown below would be announced every second -->
    <span class="sr-only" role="alert">{{ warningAnnouncement }}</span>
    <span aria-hidden="true">{{ warningText }}</span>
  </div>
}